export type TSuggestElement = {
  name: string
  type: ESuggestType
  image?: string
  hitCount: number
  attributes?: TSuggestAttribute
  searchParams?: TSuggestSearchParams
  score?: number
}

export type TSuggestAttribute = {
  articleNr?: string
  id?: string
  masterId?: string
  parentCategory?: string
  sourceField?: string
}

export type TSuggestSearchParams = {
  query: string
  filters?: TSuggestFilter[]
  channel: string
  customParameters?
}

export type TSuggestFilter = {
  name: string
  values: TSuggestFilterValue[]
}

export type TSuggestFilterValue = {
  value: string
  type: string
  exclude: boolean
}

export const enum ESuggestType {
  BRAND = 'brand',
  CATEGORY = 'category',
  PRODUCT = 'productName',
}
